import { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

export const Toast = ({
  message,
  type = 'success',
  isVisible,
  onClose,
  duration = 3000
}: ToastProps) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const config = {
    success: {
      icon: CheckCircle,
      bg: 'bg-[#ECFDF5]',
      border: 'border-[#10B981]',
      text: 'text-[#10B981]'
    },
    error: {
      icon: XCircle,
      bg: 'bg-[#FEE2E2]',
      border: 'border-[#DC2626]',
      text: 'text-[#DC2626]'
    },
    info: {
      icon: AlertCircle,
      bg: 'bg-[#FFF5F0]',
      border: 'border-[#FF6A2A]',
      text: 'text-[#FF6A2A]'
    }
  };

  const { icon: Icon, bg, border, text } = config[type];

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 animate-[slideDown_0.3s_ease-out]">
      <div className={`${bg} ${border} border-2 rounded-[14px] px-5 py-3.5 shadow-lg flex items-center gap-3 min-w-[280px] max-w-md`}>
        <Icon className={`w-5 h-5 ${text} flex-shrink-0`} />
        <p className={`font-semibold ${text}`}>{message}</p>
      </div>
    </div>
  );
};
